import { compose } from 'redux';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';

import primoAccountSaga from 'containers/PrimoAccount/saga';
import primoProfileSaga from 'containers/PrimoProfile/saga';
import primoProfileReducer from 'containers/PrimoProfile/reducer';
import primoAccountReducer from 'containers/PrimoAccount/reducer';
import PrimoAccount from 'containers/PrimoAccount/PrimoAccount';
import { PROFILE_PAGE_KEY } from 'containers/PrimoProfile/constants';
import { PRIMO_ACCCOUNT_PAGE_KEY } from './constants';

const withSaga = injectSaga({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  saga: primoAccountSaga,
});
const withReducer = injectReducer({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  reducer: primoAccountReducer,
});

const withPrimoProfileSaga = injectSaga({
  key: PROFILE_PAGE_KEY,
  saga: primoProfileSaga,
});
const withPrimoProfileReducer = injectReducer({
  key: PROFILE_PAGE_KEY,
  reducer: primoProfileReducer,
});

export default compose(
  withReducer,
  withPrimoProfileReducer,
  withSaga,
  withPrimoProfileSaga,
)(PrimoAccount);
